import format from 'date-fns/format'
import { PROFILE_SUBSCRIPTION_PLANS } from './subscription-plans'

const formatAmount = (amount, currency = 'usd') =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency: currency.toUpperCase() }).format(amount / 100)

const formatDate = (seconds, dateFormat) => seconds ? format(new Date(seconds * 1000), dateFormat) : null

// Formatted pieces of the invoice Stripe is retrying (`failedPayment` from the
// API, past_due only). Each piece is null when Stripe did not report it.
export const getFailedPayment = (subscription, dateFormat = 'MMM d') => {
  const failedPayment = subscription?.failedPayment
  if (!failedPayment) return null
  return {
    amount: failedPayment.amount != null ? formatAmount(failedPayment.amount, failedPayment.currency || undefined) : null,
    failedOn: formatDate(failedPayment.failedAt, dateFormat),
    retryOn: formatDate(failedPayment.retryAt, dateFormat)
  }
}

// The plan name the profile card shows.
export const planDisplayName = (planId) =>
  PROFILE_SUBSCRIPTION_PLANS.find(p => p.id === planId)?.title || 'Pro'

export const failedPaymentMessage = (user) => {
  const { amount, retryOn } = getFailedPayment(user?.subscriptionData) || {}
  const failed = amount ? `Your ${amount} payment failed.` : 'Your payment failed.'
  return `${failed} Update your card${retryOn ? ` by ${retryOn}` : ''} to avoid losing ${planDisplayName(user?.subscriptionPlan)} features.`
}
